<template>
	<div>
		<v-card class="bidders-view">
			<v-btn @click="back" class="hidden-xs-only" flat icon>
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-card-title>
				<v-layout justify-center>
					<h2>{{textInfo().title}}</h2>
					<v-spacer></v-spacer>
					<span>
						<span v-if="isLanguagePl()" style="font-size: 18px; font-weight: bold">PL</span>
						<span v-else style="font-size: 18px; text-decoration: underline; cursor: pointer"
							@click="switchLanguage()">PL</span>
						<v-icon class="mr-2 ml-2" color="white">public</v-icon>
						<span v-if="isLanguageEn()" style="font-size: 18px; font-weight: bold">EN</span>
						<span v-else style="font-size: 18px; text-decoration: underline; cursor: pointer"
							@click="switchLanguage()">EN</span>
					</span>
				</v-layout>
			</v-card-title>

			<v-layout align-center justify-center row>
				<v-flex sm1/>
				<v-flex sm2 class="ma-2 mr-3 ml-3">
					<v-text-field v-model="searchName" :label="textInfo().organizationName"
						browser-autocomplete="organization"
						aria-label="organization name"></v-text-field>
				</v-flex>
				<v-flex sm2 class="ma-2 mr-3 ml-3">
					<v-autocomplete
						browser-autocomplete="off"
						v-model="dataTable.searchFields.activityTypeId"
						:items="activityTypes"
						:item-text="isLanguageEn() ? 'englishName' : 'name'"
						item-value="id"
						:label="textInfo().activityType"
						aria-label="activity type"
						clearable
					></v-autocomplete>
				</v-flex>
				<v-flex sm2 class="ma-2 mr-3 ml-3">
					<v-autocomplete
						browser-autocomplete="off"
						v-model="dataTable.searchFields.activityCountryId"
						:items="isLanguageEn() ? activityCountriesSortedEN : activityCountriesSortedPL"
						:item-text="isLanguageEn() ? 'englishName' : 'name'"
						item-value="id"
						:label="textInfo().activityCountry"
						aria-label="activity country"
						clearable
					></v-autocomplete>
				</v-flex>
				<v-btn @click="getItemList" color="primary" dark class="mb-2">{{textInfo().searchText}}</v-btn>
				<v-btn @click="resetSearch" color="primary" dark class="mb-2">{{textInfo().resetText}}</v-btn>
				<v-flex sm1/>
			</v-layout>

			<br/>
			<br/>

			<v-flex xs12 sm6 offset-sm3>
				<v-spacer></v-spacer>
				<v-data-table
					:headers="tableHeaders()"
					:loading="dataTable.loading"
					:rows-per-page-items="[10,20,25]"
					:rows-per-page-text="rowsPerPageText()"
					:items="dataTable.itemList"
					:no-data-text="noDataText()"
					:total-items="dataTable.itemCount"
					:pagination.sync="dataTable.pagination"
					class="elevation-1">
					<template slot="items" slot-scope="props">
						<td v-if="isLanguageEn()">{{ props.item.englishName }}</td>
						<td v-else>{{ props.item.polishName }}</td>
						<td class="text-xs-left">
							<v-icon medium class="mr-2"
								@click="showDetails(props.item.id)" :title="textInfo().buttonLabel">
								notes
							</v-icon>
						</td>
					</template>
				</v-data-table>
				<v-spacer></v-spacer>
			</v-flex>
		</v-card>
		<v-footer
			primary color="white"
			class="elevation-2 d-flex"
			absolute
		>
			<div class="my-3 regulation">
				<a href="/declaration.html">
					Deklaracja dostępności
				</a>
			</div>
		</v-footer>
	</div>
</template>

<script>
	import {Api} from "@/api";
	import {ActivityType} from "@/api/generated/ActivityType";
	import {AccreditationCountry} from "@/api/generated/AccreditationCountry";

	export default {
		name: "BiddersView",

    metaInfo() {
      return {
        title: "eGranty - Wyszukiwarka",
        meta: [
          { name: 'description', content:  'Aplikacja eGranty. Wyszukiwarka zarejestrowanych organizacji.' },
          { property: 'og:title', content: 'eGranty - Wyszukiwarka' },
          { property: 'og:site_name', content: 'eGranty' },
          { property: 'og:description', content: 'Aplikacja eGranty. Wyszukiwarka zarejestrowanych organizacji.' },
          { property: 'og:type', content: 'website' },
          { property: 'robots', content: 'nosnippet' },
        ]
      };
    },

		watch: {
			"dataTable.pagination.page": function () {
				this.getItemList();
			},
		},

		created () {
			this.fetchAllActivities();
			this.fetchAllActivityCountries();
		},

		computed: {
			pages () {
				// paginacja nie została zainicjalizowana
				if (this.dataTable.pagination.rowsPerPage === undefined) {
					return 0;
				}
				return Math.ceil(this.dataTable.itemCount / this.dataTable.pagination.rowsPerPage);
			},
			searchName: {
				get () {
					if (this.isLanguageEn()) return this.dataTable.searchFields.englishName;
					else return this.dataTable.searchFields.polishName;
				},
				set (val) {
					if (this.isLanguageEn()) this.dataTable.searchFields.englishName = val;
					else this.dataTable.searchFields.polishName = val;
				},
			},
		},

		methods: {

			textInfo () {
				if (this.isLanguageEn()) return this.englishTextinfo;
				else return this.polishTextinfo;
			},
			tableHeaders () {
				if (this.isLanguageEn()) return this.dataTable.tableHeadersEn;
				else return this.dataTable.tableHeadersPl;
			},

			noDataText () {
				if (this.isLanguageEn()) {
					return this.englishTextinfo.noDataText;
				} else {
					return this.polishTextinfo.noDataText;
				}
			},

			rowsPerPageText () {
				if (this.isLanguageEn()) {
					return this.englishTextinfo.rowsPerPageText;
				} else {
					return this.polishTextinfo.rowsPerPageText;
				}
			},


			back () {
				this.$router.go(-1);
			},

			getItemList () {
				this.dataTable.search = this.buildSearch(this.searchName);
				let sort = this.buildSort();
				Api.get(this,
					"/bidder/list?search=" + this.dataTable.search
						+ "&page=" + this.dataTable.pagination.page
						+ "&result=" + this.dataTable.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.dataTable.itemList = response.itemList;
							this.dataTable.itemCount = response.itemCount;
						},
				);
			},


			buildSort () {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			resetSearch () {
				this.clearFields();
				this.getItemList();
			},

			clearFields () {
				this.searchName = "";
				this.dataTable.searchFields.activityCountryId = undefined;
				this.dataTable.searchFields.activityTypeId = undefined;
			},

			buildSearch (searchName) {
				let search = "";
				if (searchName !== "") {
					if (this.isLanguageEn()) {
						search = search.concat("englishName::" + searchName + "$$");
					} else {
						search = search.concat("polishName::" + searchName + "$$");
					}
				}
				if (this.dataTable.searchFields.activityTypeId !== undefined) {
					search = search.concat("activityTypeId::" + this.dataTable.searchFields.activityTypeId + "$$");
				}
				if (this.dataTable.searchFields.activityCountryId !== undefined) {
					search = search.concat("activityCountryId::" + this.dataTable.searchFields.activityCountryId + "$$");
				}
				return search;
			},

			switchLanguage () {
				if (this.language === "PL") {
					localStorage.setItem("language", "EN");
					document.documentElement.lang = 'en';
					this.searchText = "Search";
					this.resetText = "Reset";
				} else {
					localStorage.setItem("language", "PL");
					document.documentElement.lang = 'pl';
					this.searchText = "Szukaj";
					this.resetText = "Resetuj";
				}
				this.language = localStorage.getItem("language");
        this.resetSearch();
			},

			isLanguagePl () {
				return this.language === "PL";
			},

			isLanguageEn () {
				return this.language !== "PL";
			},

			showDetails (id) {
				this.$router.push("/bidder-details/" + id);
			},

			async fetchAllActivities () {
				ActivityType.getListAll(this, success => {
					this.activityTypes = success;
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się wczytać rodzaju działalności", errorResponse);
				});
			},

			async fetchAllActivityCountries () {
				AccreditationCountry.getListAll(this, successResponse => {
					this.activityCountriesSortedPL = Array.from(successResponse).sort((a, b) => {
            if (a.name)
              return b.name ? a.name.localeCompare(b.name) : -1;
            else if (b.name)
              return a.name ? b.name.localeCompare(a.name) : 1;
            else
              return -1;
          });
					this.activityCountriesSortedEN = Array.from(successResponse).sort((a, b) => {
            if (a.englishName)
              return b.englishName ? a.englishName.localeCompare(b.englishName) : -1;
            else if (b.englishName)
              return a.englishName ? b.englishName.localeCompare(a.englishName) : 1;
            else
              return -1;
          });
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się wczytać krajów działalności", errorResponse);
				});
			},

		},

		data () {
			return {
				dataTable: {
					searchFields: {
						polishName: "",
						englishName: "",
						activityCountryId: undefined,
						activityTypeId: undefined,
					},
					tableHeadersPl: [
						{text: "Nazwa organizacji", value: "polishName", sortable: false, width: "85%"},
						{text: "Szczegóły", value: "details", sortable: false, width: "15%"},
					],
					tableHeadersEn: [
						{text: "Organization name", value: "englishName", sortable: false, width: "85"},
						{text: "Details", value: "details", sortable: false, width: "15%"},
					],
					loading: false,
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
					},
					search: "",
				},
				polishTextinfo: {
					title: "Wyszukiwarka",
					organizationName: "Nazwa organizacji",
					activityCountry: "Kraj działalności",
					activityType: "Rodzaj działalności",
					searchText: "Szukaj",
					resetText: "Resetuj",
					buttonLabel: "Pokaż szczegóły organizacji",
					noDataText: "Brak danych",
					rowsPerPageText: "Wierszy na stronie",
				},
				englishTextinfo: {
					title: "Search Engine",
					organizationName: "Organization name",
					activityCountry: "Activity Country",
					activityType: "Activity Type",
					searchText: "Search",
					resetText: "Reset",
					buttonLabel: "Show organization details",
					noDataText: "No data available",
					rowsPerPageText: "Rows per page",
				},
				language: localStorage.getItem("language") || "PL",
				activityTypes: [],
				activityCountriesSortedPL: [],
				activityCountriesSortedEN: [],
			};
		},
	};
</script>

<style scoped>
  .bidders-view {
    padding-bottom: 120px;
  }
</style>
